import { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import LowStockAlertModal from '../common/LowStockAlertModal';

export const LOW_STOCK_ALERT_ENABLED_KEY = 'lowStockAlertEnabled';

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [lowStockAlertEnabled, setLowStockAlertEnabled] = useState(
    () => localStorage.getItem(LOW_STOCK_ALERT_ENABLED_KEY) !== 'false'
  );

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const toggleLowStockAlert = () => {
    setLowStockAlertEnabled((prev) => {
      const next = !prev;
      localStorage.setItem(LOW_STOCK_ALERT_ENABLED_KEY, String(next));
      return next;
    });
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      <Header
        toggleSidebar={toggleSidebar}
        lowStockAlertEnabled={lowStockAlertEnabled}
        onToggleLowStockAlert={toggleLowStockAlert}
      />

      <main className="lg:ml-64 pt-16">
        <div className="p-6">
          {children}
        </div>
      </main>

      {lowStockAlertEnabled && <LowStockAlertModal />}
    </div>
  );
};

export default Layout;
